const templateNames = {
  "stock-adjustment": {
    en: "Adjustment.xlsx",
    es: "Ajuste.xlsx",
    pt: "Ajuste.xlsx",
  },
  tasks: {
    en: "Tasks.xlsx",
    es: "Tareas.xlsx",
    pt: "Tarefas.xlsx",
  },
  assets: {
    en: "Assets.xlsx",
    es: "Activos.xlsx",
    pt: "Ativos.xlsx",
  },
  readings: {
    en: "Readings.xlsx",
    es: "Lecturas.xlsx",
    pt: "Leituras.xlsx",
  },
  users: {
    en: "Users.xlsx",
    es: "Usuarios.xlsx",
    pt: "Usuarios.xlsx",
  },
  supplies: {
    en: "Supplies.xlsx",
    es: "Insumos.xlsx",
    pt: "Insumos.xlsx",
  },
  components: {
    en: "Components.xlsx",
    es: "Componentes.xlsx",
    pt: "Componentes.xlsx",
  },
  "additional-data": {
    en: "Additional-Data.xlsx",
    es: "Datos-Adicionales.xlsx",
    pt: "Dados-Adicionais.xlsx",
  },
  parameters: {
    en: "Parameters.xlsx",
    es: "Parámetros.xlsx",
    pt: "Parametros.xlsx",
  },
  "program-details": {
    en: "Program-Details.xlsx",
    es: "Detalles-Programa.xlsx",
    pt: "Detalhes-Programa.xlsx",
  },
  programs: {
    en: "Programs.xlsx",
    es: "Programas.xlsx",
    pt: "Programas.xlsx",
  },
  providers: {
    en: "Providers.xlsx",
    es: "Proveedores.xlsx",
    pt: "Fornecedores.xlsx",
  },
  structures: {
    en: "Structures.xlsx",
    es: "Estructuras.xlsx",
    pt: "Estruturas.xlsx",
  },
  "stock-point": {
    en: "Stock-Point.xlsx",
    es: "Punto-Stock.xlsx",
    pt: "Ponto-Estoque.xlsx",
  },
};

export function getExcelTemplateName(templateKey) {
  const lang = localStorage.getItem("i18nextLng") || "es";
  const template = templateNames[templateKey];

  if (!template) {
    return `${templateKey}.xlsx`;
  }

  return template[lang] || template.es;
}

export default templateNames;
